import { render } from "./MrateTypeIndex.vue?vue&type=template&id=2cfb607c&scoped=true"
import script from "./MrateTypeIndex.vue?vue&type=script&lang=js"
export * from "./MrateTypeIndex.vue?vue&type=script&lang=js"

import "./MrateTypeIndex.vue?vue&type=style&index=0&id=2cfb607c&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfb607c"]])

export default __exports__